import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';

import { AuthService } from '../../features/auth/services/auth.service';
import { PermissionService } from '../services/permission.service';

export const masterAdminGuard: CanActivateFn = (): boolean | UrlTree | Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const evaluateAccess = (): boolean | UrlTree => (permissionService.isCurrentUserMasterAdmin() ? true : router.createUrlTree(['/dashboard']));

  if (!authService.isInitialized()) {
    return authService.waitForInitialization().pipe(map(() => evaluateAccess()));
  }

  return evaluateAccess();
};
